import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import Members from './components/Members';
import Schedule from './components/Schedule';
import Trainers from './components/Trainers';
import Classes from './components/Classes';
import Events from './components/Events';
import Attendance from './components/Attendance';
import WorkoutTemplateBuilder from './workout-module/components/WorkoutPlanBuilder';
import WorkoutTemplateList from './workout-module/components/WorkoutTemplateList';
import MemberWorkoutDashboard from './workout-module/components/MemberWorkoutDashboard';
import ExerciseLibrary from './workout-module/components/ExerciseLibrary';
import ProgressTracker from './workout-module/components/ProgressTracker';
import WorkoutCalendar from './workout-module/components/WorkoutCalendar';
import WorkoutSession from './workout-module/components/WorkoutSession';
import Login from './components/Login';


function App() {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        // Strictly check for admin or staff
        if (decoded.role === 'admin' || decoded.role === 'staff') {
          setLoggedIn(true);
        } else {
          console.warn('Unauthorized role:', decoded.role);
          localStorage.removeItem('token');
          setLoggedIn(false);
        }
      } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem('token');
        setLoggedIn(false);
      }
    }
  }, []);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <Router>
      {loggedIn ? (
        <div className="d-flex" id="wrapper">
          {sidebarVisible && <Sidebar setLoggedIn={setLoggedIn} />}
          <div id="page-content-wrapper" className="w-100">
            <Navbar toggleSidebar={toggleSidebar} />
            <div className="container-fluid p-4">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/members" element={<Members />} />
                <Route path="/trainers" element={<Trainers />} />
                <Route path="/classes" element={<Classes />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/events" element={<Events />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/workout-templates" element={<WorkoutTemplateList />} />
                <Route path="/workout-template-builder" element={<WorkoutTemplateBuilder />} />
                <Route path="/workout-template-builder/:templateId" element={<WorkoutTemplateBuilder />} />
                <Route path="/member-workout-dashboard/:memberId" element={<MemberWorkoutDashboard />} />
                <Route path="/exercise-library" element={<ExerciseLibrary />} />
                <Route path="/progress-tracker/:memberId" element={<ProgressTracker />} />
                <Route path="/workout-calendar/:memberId" element={<WorkoutCalendar />} />
                <Route path="/workout-session/:planId/:memberId" element={<WorkoutSession />} />
                <Route path="/login" element={<Navigate to="/" />} />
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<Login setLoggedIn={setLoggedIn} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;